
/**
 * Workspace collaborator role
 * @export
 * @enum {string}
 */
export enum CollaboratorRole {
    OWNER = 'OWNER',
    EDITOR = 'EDITOR',
    VIEWER = 'VIEWER'
}